import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthGuard } from "./components/AuthGuard";
import Home from "./pages/Home";
import MatchView from "./pages/MatchView";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminMatchEditor from "./pages/AdminMatchEditor";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/match/:matchId" element={<MatchView />} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AuthGuard />}>
          <Route index element={<AdminDashboard />} />
          <Route path="match/new" element={<AdminMatchEditor />} />
          <Route path="match/:matchId/edit" element={<AdminMatchEditor />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
